import Common from '../../Common';

export type PartnerReadBranding = ("alpha" | "beta" | "stable" | "betaarm64" | "stablearm64")[]

export interface PartnerRead {
	android_app_name: string
	added: string
	app_android_url?: string
	app_iphone_url?: string
	branding_name: string
	class_name: string
	communicator_version_mac: PartnerReadBranding
	communicator_version_mac_v2: PartnerReadBranding
	communicator_version_windows: PartnerReadBranding
	communicator_version_windows_v2: PartnerReadBranding
	desktop_app_name: string
	logo_url: string
	long_name: string
	main_color: string
	mobile_app_name: string
	name: string
	no_reply_mail: string
	portal_url: string
	secondary_color?: string
	short_product_name: string
	support_mail: string
	support_tel: string
	support_web: string
}

const Partner = class extends Common {
	read = (companyId: id): CustomResponse<PartnerRead> =>
		this.get(`/company/${companyId}/partner`)
}

export default Partner
